const COLLECTION = 'cargoflow_demo_registrations';

/**
 * POST demo registration to Directus.
 * Set REACT_APP_DIRECTUS_URL (and optionally REACT_APP_DIRECTUS_STATIC_TOKEN) in .env.
 * Note: CRA only exposes env vars prefixed with REACT_APP_.
 */
export async function createDirectusDemoRegistration(data) {
  const { company, email, expectedDuas } = data;

  const DIRECTUS_URL = process.env.REACT_APP_DIRECTUS_URL;

  if (!company || !email || expectedDuas == null) {
    return {
      success: false,
      error: 'Missing required fields: company, email, expectedDuas',
    };
  }

  if (!DIRECTUS_URL || !String(DIRECTUS_URL).trim()) {
    return {
      success: false,
      error: 'Demo registration is not configured. Please contact support.',
    };
  }

  try {
    const baseUrl = String(DIRECTUS_URL).replace(/\/$/, '');
    const payload = {
      company: String(company),
      email: String(email),
      expected_duas: Number(expectedDuas) || 0,
      submitted_at: new Date().toISOString(),
    };

    const headers = {
      'Content-Type': 'application/json',
    };
    const token = process.env.REACT_APP_DIRECTUS_STATIC_TOKEN;
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const url = `${baseUrl}/items/${COLLECTION}`;
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const errText = await res.text();
      console.error('Directus API error:', res.status, errText);
      return {
        success: false,
        error:
          errText ||
          `Directus request failed: ${res.status} ${res.statusText}`,
      };
    }

    const result = await res.json();
    return { success: true, data: result.data || result };
  } catch (error) {
    console.error('Demo registration error:', error);
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Internal server error',
    };
  }
}
